export const spacing = 10;

export default spacing;
